/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcelInboundPicVo } from './ParcelInboundPicVo';
import {
    ParcelInboundPicVoFromJSON,
    ParcelInboundPicVoFromJSONTyped,
    ParcelInboundPicVoToJSON,
    ParcelInboundPicVoToJSONTyped,
} from './ParcelInboundPicVo';

/**
 * 
 * @export
 * @interface ResponseListParcelInboundPicVo
 */
export interface ResponseListParcelInboundPicVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListParcelInboundPicVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListParcelInboundPicVo
     */
    message?: string;
    /**
     * 
     * @type {Array<ParcelInboundPicVo>}
     * @memberof ResponseListParcelInboundPicVo
     */
    data?: Array<ParcelInboundPicVo>;
}

/**
 * Check if a given object implements the ResponseListParcelInboundPicVo interface.
 */
export function instanceOfResponseListParcelInboundPicVo(value: object): value is ResponseListParcelInboundPicVo {
    return true;
}

export function ResponseListParcelInboundPicVoFromJSON(json: any): ResponseListParcelInboundPicVo {
    return ResponseListParcelInboundPicVoFromJSONTyped(json, false);
}

export function ResponseListParcelInboundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListParcelInboundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ParcelInboundPicVoFromJSON)),
    };
}

export function ResponseListParcelInboundPicVoToJSON(json: any): ResponseListParcelInboundPicVo {
    return ResponseListParcelInboundPicVoToJSONTyped(json, false);
}

export function ResponseListParcelInboundPicVoToJSONTyped(value?: ResponseListParcelInboundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ParcelInboundPicVoToJSON)),
    };
}

